import type { Translations } from '../i18n';

const fr: Translations = {
  // ── Nav ──────────────────────────────────────────────────────────────────────
  'nav.map': 'Carte',
  'nav.myRoutes': 'Mes itinéraires',
  'nav.collections': 'Collections',
  'nav.stats': 'Stats',
  'nav.method': 'Méthode',
  'nav.login': 'Se connecter',
  'nav.account': 'Mon compte',
  'nav.ariaLabel': 'Navigation principale',
  'nav.menu': 'Menu',
  'nav.myStats': 'Voir mes stats',
  'nav.myTraces': 'Mes traces',
  'nav.contribute': 'Importer / Contribuer',
  'nav.menuAriaLabel': 'Menu de navigation',
  'nav.privacy': 'Confidentialité',
  'nav.support': 'Support',
  'nav.overlay': 'Exporter la heatmap par sport (calque)',

  // ── Members-only community EXPORT gate (2026-07 posture) ───────────────────
  // The community MAP is public (anyone can view the heatmap); only the bulk
  // ODbL community-data EXPORT is members-only — it's the conversion point.
  'exportGate.title': 'Connecte-toi pour exporter les données communautaires',
  'exportGate.subtitle': "L'export ODbL du fond communautaire est réservé aux membres — connecte-toi pour le télécharger, et contribue tes propres traces pour enrichir la carte.",
  'exportGate.cta': 'Connecte-toi pour exporter les données communautaires ODbL',
  'exportGate.sub': "Email uniquement, sans mot de passe — on t'envoie un lien de connexion. Une fois connecté·e, tu peux exporter le fond communautaire et déposer tes traces.",

  // ── Community heatmap EXPORT modal (formats, bbox, async, ODbL) ────────────
  'export.title': 'Exporter le fond communautaire (heatmap)',
  'export.intro': "Téléchargez la couche communautaire (toutes les traces partagées par les contributeurs). Données publiées sous licence ODbL 1.0 — attribution et partage à l'identique requis. Usage dans un produit fermé sans partage à l'identique : licence commerciale séparée, contactez-nous.",
  'export.calque.title': '🗺️ La heatmap PAR SPORT en calque (gpx.studio / VisuGPX)',
  'export.calque.bodyBefore': 'Affichez la heatmap d\'UN sport (route, gravel, VTT, course…) en fond et tracez par-dessus — URL ci-dessous pour Route, les autres sports sur le tuto. Dans gpx.studio ou VisuGPX, ajoutez une ',
  'export.calque.bodyStrong': 'couche de carte personnalisée',
  'export.calque.bodyAfter': ' (type raster / XYZ) avec cette URL de tuiles :',
  'export.calque.copy': 'Copier',
  'export.calque.copied': '✓ Copié',
  'export.calque.tutorialCta': 'Utilise la heatmap comme calque (tuto pas-à-pas + par sport)',
  'export.downloads.legend': 'Téléchargements',
  'export.pmtiles.desc': '— vector tiles, France entière, MapLibre / pmtiles.js',
  'export.geojsonl.desc': '— GeoJSON par lignes (gzip), France entière, gpx.studio / QGIS',
  'export.odbl.before': "J'accepte la licence ",
  'export.odbl.after': " (attribution « © CHEMINS COMMUNS contributors » requise, partage à l'identique).",
  'export.cancel': 'Annuler',
  'export.download': 'Télécharger',

  'support.breadcrumb': 'Support & aide',
  'support.title': 'Support & aide',
  'support.intro': "Chemins Communs est un projet open source porté par une petite équipe. On répond personnellement à chaque message — voici comment nous joindre.",
  'support.contactTitle': 'Nous contacter',
  'support.contactText': "Une question, un retour, une demande liée à vos données ou à votre compte ? Écrivez-nous par email, on répond généralement sous quelques jours.",
  'support.dataTitle': 'Vos données',
  'support.dataText': "Vos traces et activités vous appartiennent. Vous pouvez les supprimer à tout moment depuis votre compte, et révoquer l'accès à un compte tiers (Strava, Garmin) côté plateforme.",
  'support.dataLink': 'Lire la politique de confidentialité',
  'support.backToMap': '← Retour à la carte',
  'strava.viewOn': 'Voir sur Strava',

  // ── Mobile ──────────────────────────────────────────────────────────────────

  // ── Common ───────────────────────────────────────────────────────────────────
  'common.close': 'Fermer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.save': 'Enregistrer',
  'common.back': '← Retour',
  'common.or': 'ou',
  'common.create': 'Créer',
  'common.retry': 'Réessayer',
  'common.loading': 'Chargement…',
  'common.noName': 'Sans nom',
  'common.all': 'Tous',
  'common.restore': 'Restaurer',
  'common.details': 'Détails',
  'common.clear': 'Effacer',
  'common.appName': 'Chemins Communs',

  // ── Route actions (ViewedRoutePanel) ────────────────────────────────────────
  'route.share': 'Partager',
  'route.edit': 'Modifier',
  'route.fork': 'Dupliquer en variante',
  'route.forkSuccess': 'Variante créée ✓',
  'route.viewOriginal': "Voir l'original",
  'route.variantsBy_one': "{count} cycliste l'a adaptée",
  'route.variantsBy_other': "{count} cyclistes l'ont adaptée",
  'route.variantsHint': 'Activez une variante pour la superposer sur la carte',

  // ── Sports ───────────────────────────────────────────────────────────────────
  'sport.road': 'Route',
  'sport.gravel': 'Gravel',
  'sport.mtb': 'VTT',
  'sport.offroad': 'Off-road',
  'sport.running': 'Course / Trail',
  'sport.running_short': 'Course à pied',
  'sport.running_desc': 'Sentiers piétons, trails',

  // ── Surfaces ─────────────────────────────────────────────────────────────────
  'surface.asphalt': 'asphalte',
  'surface.gravel': 'gravel',
  'surface.dirt': 'terre',
  'surface.rock': 'rocher',
  'surface.unknown': 'inconnu',
  'surface.mixed': 'mixte',

  // ── POI types ────────────────────────────────────────────────────────────────
  'poi.water': 'Eau',
  'poi.food': 'Ravitaillement',
  'poi.camp': 'Bivouac',
  'poi.shelter': 'Abri',
  'poi.shop': 'Commerce',
  'poi.train': 'Gare',
  'poi.viewpoint': 'Point de vue',
  'poi.custom': 'Autre',

  // ── Server wakeup banner ─────────────────────────────────────────────────────
  'wakeup.ready': 'Serveur prêt !',
  'wakeup.starting': 'Démarrage du serveur…',
  'wakeup.startingLabel': 'Démarrage — {label}…',

  // ── Layout ───────────────────────────────────────────────────────────────────
  'layout.beta': 'Version bêta — envoyez vos bugs avec un maximum de détails et de screenshots à',
  'layout.description': 'Tracez vos itinéraires vélo, gravel et VTT guidés par les traces GPS de la communauté. Open source, données libres (ODbL).',
  'layout.ogAlt': 'Chemins Communs — carte communautaire des traces cyclistes',

  // ── Home page ────────────────────────────────────────────────────────────────
  // Tagline = the value prop, visible on EVERY viewport (the subtitle is hidden
  // on mobile and short viewports) — it must carry the whole pitch on its own
  // (Paul, 2026-09-05: heatmap power at a glance).
  'home.hero.tagline': 'La heatmap communautaire du vélo : plus un chemin est roulé, plus il brille. De quoi tracer de vrais parcours.',
  // {thesis} = common.thesis — the project's motto, quoted here and on /methode
  // from ONE key so the two pages can't drift apart.
  'home.hero.subtitle': '« {thesis} » Route, gravel, VTT — carte ouverte et gratuite, bâtie par les traces que vous partagez, libre sous licence ODbL.',
  'common.thesis': 'Les chemins appartiennent à ceux qui les parcourent.',
  'home.hero.legendLow': 'peu roulé',
  'home.hero.legendHigh': 'très roulé',
  'home.stats.contributors': 'contributeurs',
  'home.stats.traces': 'traces',
  'home.stats.km': 'km de chemins',
  'home.community.title': "C'est quoi une heatmap (ou carte de popularité), et pourquoi c'est utile ?",
  'home.community.text': "Une heatmap — ou carte de popularité — colore les chemins selon le nombre de cyclistes qui les empruntent réellement. Plus c'est foncé, plus c'est roulé : d'un coup d'œil vous voyez les itinéraires que les locaux privilégient, et ceux qu'ils évitent.\n\nStrava a popularisé cette idée mais l'a verrouillée derrière un abonnement. Ici c'est libre et collectif : chaque trace importée enrichit la carte pour tout le monde, sous licence ODbL. Vos départs et arrivées sont masqués pour protéger votre domicile.",
  'home.elevation.title': "Profil d'élévation & surfaces",
  'home.elevation.desc': "Altitude Copernicus DEM, profil coloré par pente, estimation des revêtements avec indice de confiance. D+ et D- sur chaque trace.",
  'home.trails.desc': 'Pistes de Défense des Forêts (DFCI) et sentiers balisés GR, GRP, GT, PR, EuroVelo affichés sur la carte.',
  'home.openSource.text': "Vos GPS ne devraient pas enrichir des plateformes fermées. Ici, chaque trace partagée reste un bien commun — données ouvertes ODbL, code source AGPLv3.",
  // Hero overlay + section headings (previously hardcoded FR literals → caused
  // the mixed-language hero: t()'d strings followed the locale, these did not)
  // Placement-neutral label (footer + logged-in hero); the "sans compte"
  // acquisition variant is hero-only, for visitors without an account.
  'home.hero.exploreMap': 'Explorer la heatmap →',
  'home.hero.exploreMapNoAccount': 'Explorer la heatmap — sans compte →',
  'home.hero.contribute': 'Contribuer à la carte',
  'home.hero.connected': 'Connecté',
  'home.hero.logout': 'Déconnexion',
  'home.hero.join': 'Ajoutez vos traces à la carte 🚴',
  'home.hero.joinSub': 'Créez votre compte en 1 email, puis importez votre export Strava, Garmin ou vos GPX.',
  'home.onboarding.ctaTitle': 'Prêt à faire apparaître vos chemins sur la carte ?',
  'home.onboarding.cta': 'Créer mon compte et importer mes traces →',
  'home.onboarding.ctaSub': 'Gratuit · Strava, Garmin ou GPX · données ouvertes ODbL',
  'home.hero.disconnected': 'Vous avez bien été déconnecté.',
  'home.badge.anonymized': 'Extrémités masquées',
  'home.badge.openSource': 'Open source',
  'home.section.howItWorks': 'Comment ça marche',
  'home.section.howItWorksSub': 'De la heatmap communautaire à vos propres traces, en trois étapes.',
  'home.step1.title': "Profitez d'une heatmap",
  'home.step1.desc': 'Explorez les chemins réellement roulés par la communauté — les vrais itinéraires, pas les lignes dessinées par un algorithme.',
  'home.step2.title': 'Exportez vos données',
  // {strava} / {garmin} are placeholders → rendered as real links in app/page.tsx.
  'home.step2.desc': 'Depuis {strava}, {garmin} ou vos fichiers GPX — chaque trace partagée enrichit la carte commune, sous licence ODbL.',
  'home.step2.strava': 'Strava',
  'home.step2.garmin': 'Garmin',
  'home.step3.title': 'Tracez de vrais parcours',
  'home.step3.desc': "Jamais tracé de parcours ? Suivez les chemins les plus lumineux : la heatmap vous donne un GPX propre, prêt pour gpx.studio, VisuGPX ou votre GPS.",
  "home.calque.title": "🗺️ Utilise la heatmap par sport comme calque",
  "home.calque.intro": "Affiche la heatmap en fond dans gpx.studio et trace ton itinéraire par-dessus. 30 secondes : Settings → Map Layers → Custom layers, et colle cette URL :",
  "home.calque.copy": "Copier",
  "home.calque.copied": "✓ Copié",
  "home.calque.tutorialCta": "Tuto pas-à-pas + calque par sport",
  'home.trails.title': 'Pistes DFCI · Sentiers balisés GR / GRP / GT / PR / EuroVelo',
  'home.philosophy.title': 'Reprendre le contrôle de nos traces',
  'home.philosophy.method': 'Méthodologie',
  'home.footer.license': 'ODbL 1.0 · Extrémités masquées · AGPLv3',

  // ── Home — Auth ──────────────────────────────────────────────────────────────
  'home.auth.login': 'Connexion',
  'home.auth.register': 'Inscription',
  'home.auth.username': "Nom d'utilisateur",
  'home.auth.email': 'Email',
  'home.auth.password': 'Mot de passe',
  'home.auth.loginBtn': 'Se connecter',
  'home.auth.registerBtn': 'Créer mon compte',
  'home.auth.stravaLogin': 'Connexion avec Strava',

  // ── Passwordless email login (magic link) ────────────────────────────────────
  'emailAuth.title': 'Créer un compte ou se connecter',
  'emailAuth.subtitle': 'Entrez votre email — on vous envoie un lien de connexion.',
  'emailAuth.emailPlaceholder': 'vous@exemple.fr',
  'emailAuth.sendBtn': 'Recevoir mon lien',
  'emailAuth.sending': 'Envoi…',
  'emailAuth.sentTitle': 'Vérifiez votre boîte mail ✉️',
  'emailAuth.sentBody': "Si un compte existe pour cette adresse, un lien de connexion vient d'être envoyé. Le lien est valable 15 minutes.",
  'emailAuth.resend': 'Renvoyer un lien',
  'emailAuth.error': "Échec de l'envoi. Réessayez dans un instant.",
  'emailAuth.verifying': 'Connexion en cours…',
  'emailAuth.verifySuccess': 'Connecté ! Redirection…',
  'emailAuth.verifyError': 'Ce lien de connexion est invalide ou a expiré.',
  'emailAuth.verifyMissingToken': 'Lien de connexion incomplet.',
  'emailAuth.backHome': "Retour à l'accueil",

  // Account unification — add/confirm a real email on a Strava-only account.
  'accountEmail.bannerTitle': 'Ajoutez votre email',
  'accountEmail.bannerBody': 'Reliez une adresse email à votre compte pour vous reconnecter sans Strava et recevoir vos notifications (nouvelle sortie sur la carte, etc.).',
  'accountEmail.placeholder': 'vous@exemple.fr',
  'accountEmail.submit': 'Ajouter mon email',
  'accountEmail.sending': 'Envoi…',
  'accountEmail.sentTitle': 'Vérifiez votre boîte mail ✉️',
  'accountEmail.sentBody': "Un lien de confirmation vient d'être envoyé à cette adresse. Cliquez dessus pour finaliser — l'adresse n'est rattachée qu'une fois confirmée.",
  'accountEmail.conflict': 'Cet email est déjà utilisé par un autre compte. Connectez-vous plutôt avec le login email.',
  'accountEmail.error': "Échec de l'envoi. Réessayez dans un instant.",
  'accountEmail.confirming': 'Confirmation en cours…',
  'accountEmail.confirmSuccess': 'Email confirmé ! Redirection…',
  'accountEmail.confirmError': 'Ce lien de confirmation est invalide ou a expiré.',
  'accountEmail.confirmMissingToken': 'Lien de confirmation incomplet.',
  'accountEmail.backToStrava': 'Retour à Strava',

  // ── Map page ─────────────────────────────────────────────────────────────────
  'map.basemap.cyclOSM': 'CyclOSM — dénivelé et infra vélo',
  'map.elevCalc': 'Calcul du dénivelé optimal…',
  'map.gravelCheck': 'On vérifie que ça passe en gravel…',
  'map.importSuccess': '✓ {count} activité(s) importée(s)',
  'map.gpxDownloaded': '✓ GPX téléchargé',
  'map.importFailed': '{count} échouée{s}',
  'map.betaBanner': 'Beta — chaque trace GPS importée enrichit la carte communautaire.',
  'map.highContrast': 'Contraste élevé',
  'map.sidebarStats': 'Distance, dénivelé, records…',
  'map.activitiesCount': '{count} activité{s} importée{s2}',
  'map.importTitle': 'Importer / Contribuer',
  'map.import.launcherBody': 'Un seul endroit pour contribuer vos traces à la carte commune : dépose tes GPX, FIT ou une archive Strava / Garmin / Komoot, avec un seul consentement ODbL.',
  'map.import.launcherCta': 'Importer / Contribuer mes traces',
  'map.close': 'Fermer',
  'map.euroVeloTitle': 'EuroVelo · itinéraires cyclables européens',
  'map.layerEuroVelo': 'EuroVelo',
  'map.layerMtbTrails': 'VTT balisé',
  'map.layerEuroVeloMtb': 'EuroVelo / VTT balisé',
  'map.traceImported': '✓ Trace importée ! Heatmap en cours de mise à jour...',

  // ── Map — Routing explanations ───────────────────────────────────────────────
  'map.elevLoading': 'Chargement dénivelé…',
  'map.elevUnavailable': "Données d'altitude indisponibles — profil estimé",
  'map.surfaceMethodology': "Méthodologie : les pourcentages sont calculés sur la distance connue uniquement (tags OSM surface). Les segments sans données fiables sont reportés séparément.",
  'map.surfaceDisclaimer': '% calculés sur distance connue · hover pour méthodo',

  // ── Map — Garmin import panel ────────────────────────────────────────────────

  // ── Map — How routing works panel ────────────────────────────────────────────
  'map.howRouting.title': "Comment est calculé l'itinéraire ?",
  'map.howRouting.intro': "Nous ne cherchons pas le trajet le plus court. Nous cherchons un itinéraire cohérent — un parcours qu'on aurait envie de rouler.",
  'map.howRouting.frequency': 'Fréquentation réelle',
  'map.howRouting.frequencyDesc': "les chemins que d'autres cyclistes empruntent déjà",
  'map.howRouting.surface': 'Type de surface',
  'map.howRouting.surfaceDesc': 'adapté à votre vélo (route, gravel, VTT…)',
  'map.howRouting.elevation': 'Dénivelé et pente',
  'map.howRouting.elevationDesc': 'effort estimé selon le profil choisi',
  'map.howRouting.trails': 'Chemins balisés',
  'map.howRouting.trailsDesc': 'GR, PR, itinéraires VTT… quand c\'est pertinent',
  'map.howRouting.detour': 'Limitation des détours',
  'map.howRouting.detourDesc': "un chemin populaire n'est jamais imposé s'il crée un détour incohérent",

  // ── Map — Annotation presets ─────────────────────────────────────────────────
  'annotation.water': "Point d'eau",
  'annotation.food': 'Ravitaillement',
  'annotation.viewpoint': 'Point de vue',
  'annotation.danger': 'Danger',
  'annotation.info': 'Info',
  'annotation.photo': 'Photo',
  'annotation.shelter': 'Refuge',
  'annotation.repair': 'Réparation',

  // ── Discover page ────────────────────────────────────────────────────────────
  'discover.hotZone': 'La communauté y roule — des coins à découvrir',
  'discover.cloneSuccess': '✓ Variante créée — ouvrez-la pour la modifier',
  'discover.noRoutes': 'Aucun itinéraire partagé pour ce sport',
  'discover.beFirst': 'Soyez le premier à partager un itinéraire !',
  'discover.beFirstDesc': 'Tracez un itinéraire sur la carte, sauvegardez-le en public, et il apparaîtra ici.',
  'discover.createFirst': '🗺️ Créer le premier itinéraire',
  'discover.discoverRoutes': '🗺️ Découvrir les itinéraires',
  'discover.sortByPlace': '📍 Triés par proximité de {placeName} · {profile}',
  'discover.sortByActivity': '📍 Triés par proximité de votre activité · {profile}',
  'discover.subtitle': 'Itinéraires partagés par la communauté · clonez, proposez des variantes',
  'discover.allSports': 'tous sports',
  'discover.unexplored.title': 'Zones pas encore couvertes',
  'discover.unexplored.subtitle': 'Pas encore couvert',
  'discover.unexplored.cta': 'Explorer →',
  'discover.unexplored.fallback': 'Zone inexplorée',
  'discover.loginToCreate': 'Connectez-vous pour créer une variante.',
  'discover.distMin': 'Dist. min (km)',
  'discover.distMax': 'Dist. max (km)',
  'discover.sortNewest': 'Plus récents',
  'discover.sortPopular': 'Plus populaires',
  'discover.compareCancel': 'Annuler',
  'discover.compareEnable': 'Comparer',
  'discover.selectedCount': '{count} itinéraires',
  'discover.refresh': 'Actualiser',
  'discover.visibleArea': 'dans la zone visible',
  'discover.popularity': 'Popularité',

  // ── Stats page ───────────────────────────────────────────────────────────────
  'stats.loginRequired': 'Connectez-vous pour voir vos stats.',
  'stats.totalDistance': 'Distance totale',
  'stats.exploredZones': 'Zones explorées',
  'stats.sportsPracticed': 'Sports pratiqués',
  'stats.personalRecords': 'Vos records personnels',
  'stats.activitiesForTotal': 'activités pour un total de',
  'stats.elevGain': 'Dénivelé positif',
  'stats.bestYear': 'a été votre meilleure année avec',
  'stats.bestMonth': 'a été votre meilleur mois avec',
  'stats.biggestClimb': '⛰️ Plus grand dénivelé',
  'stats.tracesLoading': 'Chargement de mes traces…',
  'stats.importedTracesTitle': 'Mes traces importées',
  'stats.noImportedTraces': 'Tu n’as encore importé aucune trace.',
  'stats.noImportedTracesSub': 'Dépose ton archive Strava ou tes fichiers GPX pour retrouver tes sorties ici.',
  'stats.importCta': 'Importer mes traces',
  'stats.noTraceMatch': 'Aucune trace trouvée.',
  'stats.deleteTrace': 'Supprimer cette trace',
  'stats.deleteTraceConfirm': 'Supprimer « {name} » ? Cette trace sera retirée de vos statistiques et sa contribution à la heatmap communautaire sera supprimée. Cette action est irréversible.',
  'stats.deleteTraceError': 'La suppression a échoué. Réessayez.',
  'stats.heatmapContrib': 'Données communautaires (ODbL) — {contributors} contributeur{s}, {edges} segments GPS',

  // ── Strava page ──────────────────────────────────────────────────────────────
  'strava.pageHeader': 'Contribue à la carte commune',
  'strava.pageSubtitle': 'Dépose tes traces — GPX, FIT ou une archive .zip (Strava ou Garmin) — elles rejoignent la carte commune (ODbL, extrémités masquées).',
  'strava.pageSubtitleStravaLink': 'ton export Strava',
  'strava.flow.step1': 'Récupère tes traces',
  'strava.flow.step2': 'Dépose-les ici',
  'strava.flow.step3': 'Elles rejoignent la carte (tu es averti par email)',
  'strava.contribStatus.done': 'Tu as déjà contribué {count} trace(s) à la carte commune 🙌 Ajoute tes nouvelles sorties ci-dessous.',
  'strava.contribStatus.none': "Tu n'as pas encore contribué à la heatmap — dépose tes fichiers ci-dessous pour rejoindre la carte commune.",
  'strava.signupToContribute': 'Crée ton compte pour déposer',
  'strava.signupToContributeSub': 'Gratuit, en un email — ton consentement au partage est rattaché à ton compte.',
  'strava.depositTitle': 'Déposer mes traces',
  'strava.depositSub': 'GPX, FIT ou ZIP — plusieurs fichiers acceptés.',
  'strava.stravaHelpSummary': 'Tu utilises Strava ? Récupère ton archive en 3 minutes',
  'strava.garminHelpSummary': 'Tu utilises Garmin ? Exporte tes données en 2 clics',
  'strava.garminHelpBody': "Va sur Garmin Connect › Données du compte › Exporter vos données, télécharge l'archive .zip et dépose-la ici. Astuce : déposer tes fichiers GPX individuels (Activités) est souvent plus rapide qu'un gros export.",
  'strava.garminHelpLink': 'Exporter mes données Garmin →',
  'strava.connected': 'Strava connecté !',
  'strava.preparingImport': "Préparation de l'import...",
  'strava.welcome': 'Bienvenue{name} !',
  'strava.estimatedActivities': '{n} activité{s} sur votre compte',
  'strava.loginToImport': 'Connectez-vous pour importer.',
  'strava.dataImported': 'Traces GPS, noms, distances, dénivelés',
  'strava.dataPrivate': 'Données privées — visibles uniquement par vous',
  'strava.heatmapContrib': 'Heatmap agrégée (vos traces ne sont jamais visibles individuellement) — licence ODbL',
  'strava.estimatedTime': 'Durée estimée : ~{minutes} min',
  'strava.oneByOne': 'Chaque trace GPS est téléchargée depuis Strava une par une.',
  'strava.bulkExportHint': 'Pour un import instantané et en haute résolution :',
  'strava.requestDataHint': "(cliquez \"Demander vos données\" — ça ne supprime pas votre compte).",
  'strava.activitiesFound': 'activité{s} trouvée{s2}',
  'strava.fetchingList': 'Récupération de la liste des activités...',
  'strava.alreadyPresent': 'déjà présente{s}',
  'strava.gpsUpgrade': 'Amélioration GPS haute résolution',
  'strava.apiLimit': "L'import Strava est limité par leur API (~400 activités/heure).",
  'strava.requestData': 'Strava → Paramètres → Demander vos données',
  'strava.importGpxHint': "(bouton Importer GPX). C'est instantané et en haute résolution.",
  'strava.rateLimitNote': "Limité par l'API Strava (~400 activités/heure)",

  // ── Strava — import archive perso (contribution ODbL, consentie) ───────────
  // NOTE: wording de consentement en DRAFT — à finaliser par Paul (copie légale).
  'strava.archive.title': 'Importer mon export Strava',
  'strava.archive.intro': "Déposez l'archive de VOS données Strava (celle que Strava vous envoie sur demande) : vos traces rejoignent la carte commune (ODbL), vos départs et arrivées masqués.",
  'strava.archive.whyTitle': 'Pourquoi déposer un fichier plutôt que connecter Strava ?',
  'strava.archive.whyBody': "Strava peut vous montrer vos sorties, mais pas les verser dans une carte ouverte. Vos données vous appartiennent : en les déposant vous-même, vous les partagez — vos départs et arrivées masqués — dans une carte libre que personne ne peut refermer. C'est tout l'esprit de Chemins Communs. 🚲",
  'strava.archive.reassure': "C'est l'export officiel de VOS données (votre droit d'extraction), PAS une suppression de compte. Rien n'est supprimé.",
  'strava.archive.howto': "Comment obtenir votre archive :",
  'strava.archive.s1': 'Strava → Réglages → « Mon compte »',
  'strava.archive.s2': 'Section {exportLink} → bouton « Demander votre archive » → « Commencer »',
  'strava.archive.s2LinkLabel': '« Télécharger ou supprimer votre compte »',
  'strava.archive.s3': 'Strava vous envoie un e-mail avec un lien de téléchargement (cela peut prendre plusieurs jours).',
  'strava.archive.s4': 'Téléchargez le fichier .zip, puis déposez-le ci-dessous.',
  'strava.archive.helpLink': 'Comment faire — guide officiel Strava',
  'strava.archive.exportPageLink': "Ouvrir la page d'export Strava",
  'strava.archive.dropOnHero': "Une fois le ZIP reçu par e-mail, déposez-le simplement dans la zone ci-dessus.",
  // ⚠️ LEGAL WORDING (consent v5) — any material change here must bump
  // CONTRIBUTION_CONSENT_VERSION (lib/strava-archive-consent.ts). The second
  // sentence is the dual-licensing grant: without it the project cannot sell
  // commercial licences over contributed data.
  'strava.archive.consentLabel': "Je consens à contribuer mes traces à la carte de popularité communautaire ouverte, publiée sous licence ODbL 1.0. J'accorde à Chemins Communs le droit non exclusif de les proposer aussi sous licence commerciale (les revenus financent le projet ; mes traces restent libres en ODbL). Le début et la fin de chaque activité sont masqués pour protéger mes lieux sensibles (domicile, travail).",
  'strava.archive.consentRequired': 'Cochez la case de consentement pour continuer.',
  'strava.archive.consentHint': "Cochez la case pour activer l'envoi.",
  'strava.archive.preparing': "Préparation de l'archive…",
  'strava.archive.uploadingPct': 'Envoi de votre archive… {pct}%',
  'strava.archive.finalizing': 'Finalisation de votre dépôt…',
  'strava.archive.acceptedQueued': 'Votre archive a bien été reçue — vos traces seront ajoutées à la carte progressivement.',
  'strava.archive.failed': "Échec de l'envoi de l'archive.",
  'strava.archive.importAnother': 'Déposer une autre archive',
  // Logged-out gate: the export how-to + wizard preview are shown to everyone,
  // but the actual deposit needs an account (consent is tied to a user).

  // ── Strava — fun comments ────────────────────────────────────────────────────
  'strava.fun.zigzag': 'Bizarre cette sortie en zigzag...',
  'strava.fun.bigClimb': 'Aïe les mollets sur celle-là !',
  'strava.fun.impressiveElev': 'Wow, impressionnant ce D+ !',
  'strava.fun.earlyMorning': "Tiens, une sortie à 5h du mat' ?!",
  'strava.fun.nicePass': 'Pas mal ce col, respect.',
  'strava.fun.sundayClub': 'Celle-là sent la sortie club du dimanche.',
  'strava.fun.gpsGlitch': 'GPS qui délire ou raccourci secret ?',
  'strava.fun.forest': "Une belle sortie forestière ! Pas de chasseurs j'espère ?",
  'strava.fun.rain': 'Encore une sortie sous la pluie, hein ?',
  'strava.fun.niceLoop': 'Belle boucle, zéro raccourci.',
  'strava.fun.timeTrialLike': 'On dirait un contre-la-montre !',
  'strava.fun.almostDone': 'Allez, plus que quelques activités...',
  'strava.fun.pedaling': 'Ça pédale sec par ici.',
  'strava.fun.noFlat': 'Un jour sans côte, ça existe ?',
  'strava.fun.headwind': 'Celle-là, elle sentait le vent de face !',
  'strava.fun.gravelAvg': 'Sacrée moyenne pour un gravel !',
  'strava.fun.noFlat2': 'Pas de crevaison sur celle-là ?',
  'strava.fun.novemberRain': 'Sortie sous la pluie en novembre, classique.',
  'strava.fun.bakeryStop': 'Ah, la classique pause boulangerie.',
  'strava.fun.recognizeArea': 'On reconnaît bien le coin là.',

  // ── Me / Stats ───────────────────────────────────────────────────────────────
  'meStats.loginToDownload': 'Connectez-vous pour télécharger vos données.',
  'meStats.downloaded': '✓ Données téléchargées',
  'meStats.downloadBtn': '⬇ Télécharger mes données',
  'meStats.noActivities': 'Aucune activité importée pour ce profil.',

  // ── Me / Routes ──────────────────────────────────────────────────────────────
  'meRoutes.title': 'Mes itinéraires',
  'meRoutes.loginRequired': 'Connectez-vous pour voir vos itinéraires.',
  'meRoutes.loadError': 'Impossible de charger les itinéraires : {error}',
  'meRoutes.search': 'Rechercher...',
  'meRoutes.sortLastAccessed': 'Dernier accès',
  'meRoutes.sortCreatedAt': 'Date de création',
  'meRoutes.sortDistance': 'Distance',
  'meRoutes.noRoutes': 'Aucun itinéraire trouvé.',
  'meRoutes.createOnMap': 'Créer un itinéraire sur la carte',
  'meRoutes.drafts': 'Brouillons ({count})',
  'meRoutes.routes': 'Itinéraires ({count})',
  'meRoutes.trash': 'Corbeille ({count})',
  'meRoutes.groups': 'Groupes',
  'meRoutes.routeCount': '{count} itinéraire{s}',
  'meRoutes.compareOnMap': 'Comparer sur la carte',
  'meRoutes.deleteGroup': 'Supprimer',
  'meRoutes.deleteGroupConfirm': 'Supprimer ce groupe ? Les itinéraires ne seront pas supprimés.',
  'meRoutes.newGroup': 'Nouveau groupe...',
  'meRoutes.createGroup': '+ Créer',
  'meRoutes.yourRoutes': 'Vos itinéraires',
  'meRoutes.deleteConfirm': 'Supprimer cet itinéraire ? Il sera récupérable pendant 30 jours.',

  // ── Me / Stats (extra) ─────────────────────────────────────────────────────
  'meStats.loginRequired': 'Connectez-vous pour voir vos statistiques.',
  'meStats.loadError': 'Impossible de charger les stats : {error}',
  'meStats.loading': 'Chargement des statistiques…',
  'meStats.period30d': '30 jours',
  'meStats.period1y': '12 mois',
  'meStats.periodAll': 'Tout',
  'meStats.activities': 'Activités',
  'meStats.totalDistance': 'Distance totale',
  'meStats.totalElev': 'D+ total',
  'meStats.visitedCells': 'Cellules visitées',
  'meStats.tiles': 'tuiles',
  'meStats.personalCoverage': 'Couverture personnelle',
  'meStats.exploredTiles': 'Vous avez exploré {count} tuiles distinctes en mode {profile}.',
  'meStats.last30d': '30 derniers jours',
  'meStats.last12m': '12 derniers mois',
  'meStats.coverageComingSoon': 'Les détails de couverture (carte de tuiles, top cellules) seront disponibles dans une prochaine version.',
  'meStats.importTraces': 'Importez vos premières traces',

  // ── Routes page ─────────────────────────────────────────────────────────────
  'routes.redirecting': 'Redirection…',

  // ── Activities (extra) ──────────────────────────────────────────────────────
  'activities.loading': 'Chargement…',
  'activities.missingId': 'Identifiant manquant',
  'activities.loginRequired': 'Connectez-vous pour voir vos traces.',
  'activities.notFound': 'Trace introuvable.',
  'activities.backHome': "Retour à l'accueil",
  'activities.distance': 'Distance',
  'activities.time': 'Temps',
  'activities.avgSpeed': 'Vitesse moy.',
  'activities.date': 'Date',
  'activities.noElevProfile': "Profil d'altitude non disponible — re-importez depuis Strava pour obtenir les données point par point.",
  'activities.viewOnMap': 'Voir sur la carte',
  'activities.similarRoutes': 'Itinéraires similaires →',
  'activities.linkCopied': 'Lien copié !',
  'activities.share': 'Partager',
  'activities.mapBreadcrumb': 'Carte',
  'activities.detailBreadcrumb': 'Detail de la trace',

  // ── Collections (extra) ─────────────────────────────────────────────────────
  'collections.newCollection': 'Nouvelle collection',
  'collections.nameLabel': 'Nom de la collection',
  'collections.descLabel': 'Description (optionnel)',
  'collections.cancel': 'Annuler',
  'collections.myCollections': 'Mes collections',
  'collections.public': 'Publiques',
  'collections.loadingCount': 'Chargement...',
  'collections.count': '{count} collection{s}',
  'collections.new': '+ Nouveau',
  'collections.emptyTitle': 'Aucune collection pour le moment',
  'collections.emptyDesc': 'Regroupez vos itinéraires en collections !',
  'collections.createFirst': '+ Créer une collection',
  'collections.loading': 'Chargement...',
  'collections.backToCollections': 'Retour aux collections',
  'collections.noStagesYet': 'Aucun itinéraire pour le moment',
  'collections.addRoute': '+ Ajouter un itinéraire',
  'collections.publicTab': 'Publics',
  'collections.myTracesTab': 'Mes traces',
  'collections.searchRoute': 'Rechercher un itinéraire...',
  'collections.searching': 'Recherche...',
  'collections.noResults': 'Aucun résultat',
  'collections.viewOnMap': 'Voir sur la carte',
  'collections.duplicate': 'Dupliquer',
  'collections.shareBtn': 'Partager',
  'collections.copied': 'Copié !',
  'collections.traces': 'Traces',
  'collections.addDescription': '+ Ajouter une description',
  'collections.save': 'Enregistrer',
  'collections.variant': 'Variante',
  'collections.private': 'Privé',
  'collections.planned': 'Planifié',
  'collections.draft': 'Brouillon',
  'collections.detailBreadcrumb': 'Detail',
  'collections.stageDesc': 'Description de cette trace...',
  'collections.collectionDesc': 'Description de la collection...',
  'collections.removeStageConfirm': 'Retirer cette trace de la collection ?',
  'collections.poiClickHint': 'Survolez la trace et cliquez pour placer un point',
  'collections.poiAdd': 'Ajouter',
  'collections.poiCancel': 'Annuler',
  'collections.poiNameLabel': 'Nom (optionnel)',
  'collections.mapBtn': 'Carte',

  // ── Admin (extra) ───────────────────────────────────────────────────────────
  'admin.title': 'Admin Dashboard',
  'admin.monitoring': 'CHEMINS COMMUNS — monitoring',
  'admin.updatedAt': 'mis à jour {time}',
  'admin.refresh': 'Rafraîchir',
  'admin.error': 'Erreur : {error}',
  'admin.notLoggedIn': "Non connecté — connectez-vous d'abord",
  'admin.errorStatus': 'Erreur {status}',
  'admin.resyncNow': 'Resync maintenant',
  'admin.launching': 'Lancement…',
  'admin.tokenExpired': 'Token expiré',
  'admin.never': 'Jamais',

  // ── Admin dashboard — cards / stats / columns (routed from hardcoded FR, hardening) ──
  'admin.apiRevision': 'Révision API actuelle :',
  'admin.card.users': 'Utilisateurs',
  'admin.card.activities': 'Activités',
  'admin.card.totalDistance': 'Distance totale',
  'admin.card.engagement': 'Engagement',
  'admin.card.provenance': 'Provenance des activités',
  'admin.card.bySport': 'Activités par sport',
  'admin.card.routes': 'Itinéraires',
  'admin.card.heatmap': 'Heatmap communautaire',
  'admin.card.graphHealth': 'Santé du graphe de routage',
  'admin.card.network': 'Réseau de pistes',
  'admin.card.database': 'Base de données',
  'admin.card.recentRoutes': 'Itinéraires récents',
  'admin.card.recentActivities': 'Activités récentes',
  'admin.card.recentJobs': 'Exécutions de jobs récentes',
  'admin.card.stravaSync': 'Synchronisation Strava',
  'admin.stat.signedUp': 'inscrits',
  'admin.stat.importedTraces': 'traces importées',
  'admin.stat.cumulativeDistance': 'cumulée',
  'admin.stat.cumulativeElevation': 'cumulé',
  'admin.stat.signups7d': 'inscriptions 7j',
  'admin.stat.signups30d': 'inscriptions 30j',
  'admin.stat.active7d': 'actifs 7j',
  'admin.stat.active30d': 'actifs 30j',
  'admin.stat.stravaConnected': 'Strava connectés',
  'admin.stat.total': 'total',
  'admin.stat.edges': 'edges',
  'admin.stat.cells': 'cells',
  'admin.stat.maxContributors': 'max contributeurs',
  'admin.stat.pctOnOsm': '% sur OSM',
  'admin.stat.pctGridFallback': '% grid-fallback',
  'admin.stat.vertices': 'sommets',
  'admin.stat.deadEnds': 'dead-ends',
  'admin.stat.pctDeadEnds': '% dead-ends',
  'admin.stat.dfciTracks': 'pistes DFCI',
  'admin.stat.markedTrails': 'sentiers balisés',
  'admin.stat.size': 'taille',
  'admin.stat.connected': 'connectés',
  'admin.stat.delay30d': 'retard > 30j',
  'admin.stat.tokenExpired': 'token expiré',
  'admin.provider.gpxUpload': 'Upload GPX',
  'admin.col.name': 'Nom',
  'admin.col.author': 'Auteur',
  'admin.col.sport': 'Sport',
  'admin.col.visibility': 'Visibilité',
  'admin.col.distance': 'Distance',
  'admin.col.elevation': 'D+',
  'admin.col.created': 'Créé',
  'admin.col.source': 'Source',
  'admin.col.imported': 'Importée',
  'admin.col.job': 'Job',
  'admin.col.execution': 'Exécution',
  'admin.col.status': 'Statut',
  'admin.col.start': 'Début',
  'admin.col.duration': 'Durée',
  'admin.col.athlete': 'Athlète',
  'admin.col.lastSync': 'Dernière sync',
  'admin.col.delay': 'Retard',
  'admin.col.failures': 'Échecs',
  'admin.sport.road': 'Route',
  'admin.sport.gravel': 'Gravel',
  'admin.sport.mtb': 'VTT',
  'admin.sport.offroad': 'Off-road',
  'admin.sport.running': 'Course',

  // ── Privacy (extra) ─────────────────────────────────────────────────────────
  'privacy.title': 'Politique de confidentialité',
  'privacy.whoWeAre': '1. Qui sommes-nous',
  'privacy.whoWeAreText': "CHEMINS COMMUNS — Chemins Communs est une plateforme open source (AGPLv3) de cartographie cycliste communautaire. Le code source est disponible sur",
  'privacy.responsible': 'Responsable : Paul Leclercq — contact : paul@epauler.fr',
  'privacy.dataCollectedIntro': 'Lorsque vous connectez un compte tiers (Strava, Garmin Connect) ou importez un fichier GPX, nous collectons :',
  'privacy.gpsTraces': 'Vos traces GPS (coordonnées, altitude, horodatage)',
  'privacy.thirdPartyId': 'Identifiant du compte tiers (pour la synchronisation)',
  'privacy.alsoCollect': 'Nous collectons également :',
  'privacy.email': "Adresse email (pour l'authentification)",
  'privacy.useTitle': '4. Utilisation des données',
  'privacy.displayTraces': 'Afficher vos traces sur la carte (visible uniquement par vous)',
  'privacy.feedHeatmap': 'Alimenter la carte de popularité communautaire ouverte (traces déposées volontairement, extrémités masquées)',
  'privacy.personalStats': 'Afficher vos statistiques personnelles',
  'privacy.weDontTitle': 'Nous ne faisons pas :',
  'privacy.noAds': 'Pas de publicité, pas de tracking publicitaire',
  'privacy.noSale': 'Pas de revente ou partage de données avec des tiers',
  'privacy.noProfiling': 'Pas de profilage comportemental',
  'privacy.thirdPartyTitle': '5. Intégrations tierces (Strava, Garmin Connect)',
  'privacy.retentionTitle': '7. Conservation et suppression',
  'privacy.youCan': 'Vous pouvez à tout moment :',
  'privacy.deleteActivity': 'Supprimer une activité individuelle depuis la page Statistiques (section « Mes traces »)',
  'privacy.heatmapRecalc': "La suppression d'une activité retire immédiatement sa contribution des données de la heatmap communautaire ; le fond de carte affiché est mis à jour lors de la prochaine régénération.",
  'privacy.cookiesTitle': '8. Cookies',
  'privacy.cookiesText': "Nous utilisons uniquement un cookie d'authentification (JWT) nécessaire au fonctionnement du service. Pas de cookie publicitaire, pas de cookie tiers, pas de tracking analytics.",
  'privacy.gdprTitle': '9. Vos droits (RGPD)',
  'privacy.rightRectification': 'Rectification : corriger des données inexactes',
  'privacy.rightDeletion': "Suppression : demander l'effacement de vos données",
  'privacy.rightOpposition': 'Opposition : retirer votre consentement à tout moment',
  'privacy.exerciseRights': 'Pour exercer ces droits : paul@epauler.fr',
  'privacy.changesTitle': '10. Modifications',
  'privacy.backToMap': '← Retour à la carte',
  'privacy.hostingDb': 'Base de données : Cloud SQL PostgreSQL, chiffrement au repos',
  'privacy.hostingTls': 'Communications : HTTPS obligatoire (TLS 1.2+)',
  'privacy.hostingAuth': 'Authentification : JWT avec expiration, mots de passe hachés (bcrypt)',
  'privacy.breadcrumb': 'Politique de confidentialité',

  // ── RouteCard ────────────────────────────────────────────────────────────────
  'routeCard.draft': 'Brouillon',
  'routeCard.forkedFrom': "Inspiré d'un original",
  'routeCard.forkCount': '{count} variante{s}',
  'routeCard.openMap': '🗺️ Ouvrir la carte',
  'routeCard.makePrivate': '🔒 Rendre privé',
  'routeCard.makePublic': '🌍 Rendre public',
  'routeCard.clone': '🍴 Variante',

  // ── Strava Import Banner ─────────────────────────────────────────────────────
  'importBanner.strava': 'Import Strava en cours...',
  'importBanner.gpsUpgrade': 'GPS HD : {upgraded}/{total}',
  'importBanner.importing': 'Import : {imported}/{total}',
  'importBanner.photos': 'Import des photos...',

  // ── PlaceSearch ──────────────────────────────────────────────────────────────
  'placeSearch.placeholder': 'Rechercher un lieu...',

  // ── PublicRoutesPanel ────────────────────────────────────────────────────────
  'publicRoutes.title': '🗺️ Itinéraires publics',
  'publicRoutes.count': '{count} visible{s}',
  'publicRoutes.noRoutes': 'Aucun itinéraire dans cette zone',

  // ── ErrorBoundary ────────────────────────────────────────────────────────────
  'error.title': 'Une erreur est survenue',
  'error.unknown': 'Erreur inconnue',

  // ── ElevationProfile ─────────────────────────────────────────────────────────
  'elevation.title': 'Profil altitude',

  // ── Route PRs ────────────────────────────────────────────────────────────────
  'pr.statusOpen': 'Ouverte',
  'pr.statusAccepted': 'Acceptée',
  'pr.statusRejected': 'Refusée',
  'pr.title': '🔀 Propositions ({count})',
  'pr.none': 'Aucune proposition',
  'pr.accept': 'Accepter',
  'pr.reject': 'Refuser',
  'pr.proposeToOriginal': "Proposer à l'original{name}",
  'pr.titleLabel': 'Titre de la proposition',
  'pr.descLabel': 'Description (optionnel)',
  'pr.createError': 'Erreur lors de la création de la proposition',
  'pr.networkError': 'Erreur réseau',
  'pr.createBtn': 'Créer la proposition',

  // ── Route Tags ───────────────────────────────────────────────────────────────
  'tag.title': '🏷 Jalons ({count})',
  'tag.none': 'Aucun jalon',
  'tag.add': '+ Jalon',
  'tag.nameLabel': 'Nom du jalon (ex: v1.0)',
  'tag.messageLabel': 'Message (optionnel)',
  'tag.createError': 'Erreur lors de la création du tag',
  'tag.networkError': 'Erreur réseau',

  // ── Collections ──────────────────────────────────────────────────────────────
  'collections.creating': 'Création...',
  'collections.createBtn': 'Créer la collection',
  'collections.subtitle': 'Regroupez des itinéraires par thème, région ou projet de voyage.',
  'collections.example.traversees': 'Grandes Traversées',
  'collections.example.traverseesDesc': 'GT VTT, EuroVelo, GR — les classiques balisés',
  'collections.example.region': 'Par région',
  'collections.example.regionDesc': 'Lozère, Luberon, Grands Causses...',
  'collections.example.multiday': 'Voyages multi-jours',
  'collections.example.multidayDesc': "Planifiez vos étapes, hébergements, points d'intérêt",
  'collections.example.compare': 'Comparer des variantes',
  'collections.example.compareDesc': 'Même destination, différents parcours',
  'collections.done': 'Réalisé',
  'collections.cancelPoi': '✕ Annuler',
  'collections.addPoi': "📍 Ajouter un point d'intérêt",
  'collections.poiTitle': "Points d'intérêt",
  'collections.deletePoi': "Supprimer ce point d'intérêt ?",
  'collections.poiHint': "Utilisez le bouton « 📍 Ajouter un point d'intérêt » sur la carte pour placer des points (eau, ravitaillement, bivouac...)",
  'collections.day': 'Jour {n}',
  'collections.restDay': 'Repos',
  'collections.addRestDay': '+ Jour de repos',
  'collections.tripStats': 'Aperçu',
  'collections.totalDays': '{n} jour{s}',
  'collections.avgPerDay': 'moy. {km}/jour',
  'collections.longestDay': 'plus long',
  'collections.shortestDay': 'plus court',
  'collections.lodgingCamping': 'Bivouac',
  'collections.lodgingHotel': 'Hôtel',
  'collections.lodgingRefuge': 'Refuge',
  'collections.lodgingFree': 'Libre',
  'collections.lodgingNone': 'Aucun',
  'collections.lodging': 'Hébergement',
  'collections.estimatedTime': 'Temps estimé',
  'collections.timeMin': '{n} min',
  'collections.timeH': '{h}h{m}',
  'collections.assignDay': 'Jour',
  'collections.newDay': 'Nouveau jour',
  'collections.unassociatedPois': "POI généraux",

  // ── Activities ───────────────────────────────────────────────────────────────
  'activities.elevGain': 'Dénivelé +',
  'activities.routeCreated': '✓ Itinéraire créé →',
  'activities.creating': 'Création…',
  'activities.createRoute': '🔀 Créer un itinéraire',

  // ── Admin ────────────────────────────────────────────────────────────────────
  'admin.restricted': 'Accès réservé aux administrateurs',
  'admin.totalElev': 'Dénivelé total',
  'admin.disabled': 'Désactivé',
  'admin.disabledPlural': 'désactivés',
  // ── Admin — tableau utilisateurs (observabilité) ──────────────────────
  'admin.users.section': 'Utilisateurs (détail)',
  'admin.users.empty': 'Aucun utilisateur.',
  'admin.users.count': '{n} utilisateur(s)',
  'admin.users.col.user': 'Utilisateur',
  'admin.users.col.role': 'Rôle',
  'admin.users.col.joined': 'Inscrit',
  'admin.users.col.strava': 'Strava',
  'admin.users.col.sync': 'Sync',
  'admin.users.col.traces': 'Traces',
  'admin.users.col.distance': 'Distance',
  'admin.users.col.sports': 'Sports',
  'admin.users.col.lastActivity': 'Dernière activité',
  'admin.users.role.admin': 'Admin',
  'admin.users.role.user': 'Membre',
  'admin.users.strava.none': 'Non lié',
  'admin.users.strava.viewProfile': 'Voir le profil Strava',
  'admin.users.sync.ok': 'OK',
  'admin.users.sync.reconnect': 'Reconnexion requise',
  'admin.users.sync.tokenExpired': 'Token expiré',
  'admin.users.sync.failures': '{n} échec(s)',
  'admin.users.sync.never': 'Jamais synchronisé',
  'admin.users.skipped': '{n} ignorée(s)',

  // ── Admin: heatmap monitoring (fraîcheur + évolution) ─────────────────────────
  'admin.mon.freshness': 'Fraîcheur & santé',
  'admin.mon.evolution': 'Évolution de la heatmap',
  'admin.mon.lastActivity': 'Dernière activité importée',
  'admin.mon.lastRebuild': 'Dernier rebuild heatmap',
  'admin.mon.lastResync': 'Dernier resync',
  'admin.mon.stravaSync': 'Synchro Strava',
  'admin.mon.webhook': 'Abonnement webhook Strava',
  'admin.mon.rel.never': 'jamais',
  'admin.mon.rel.now': "à l'instant",
  'admin.mon.rel.min': 'il y a {n} min',
  'admin.mon.rel.h': 'il y a {n} h',
  'admin.mon.rel.d': 'il y a {n} j',
  'admin.mon.resync.completed': 'OK',
  'admin.mon.resync.running': 'en cours',
  'admin.mon.resync.pending': 'en attente',
  'admin.mon.resync.failed': 'échec',
  'admin.mon.resync.none': 'aucun',
  'admin.mon.strava.reconnect': 'reconnexion requise',
  'admin.mon.strava.failures': '{n} échec(s) de synchro',
  'admin.mon.strava.ok': 'OK',
  'admin.mon.strava.none': 'aucun compte connecté',
  'admin.mon.webhook.present': 'présent',
  'admin.mon.webhook.missing': 'absent',
  'admin.mon.ways': '{n} chemins agrégés',
  'admin.mon.series.heatEdges': 'Segments (heat_edges)',
  'admin.mon.series.activities': 'Activités',
  'admin.mon.series.networkKm': 'Réseau (km)',
  'admin.mon.empty': "Pas encore d'historique — le premier point apparaîtra après le prochain rebuild ou le cron quotidien.",
  'admin.mon.snapshots': '{n} instantané(s)',
  'admin.mon.latest': 'actuel : {value}',

  // ── Admin : archives (contributions) — file d'attente pending_archives ───────
  'admin.archives.title': 'Archives (contributions)',
  'admin.archives.empty': 'Aucune archive déposée.',
  'admin.archives.status.awaiting_upload': "en attente d'upload",
  'admin.archives.status.uploaded': 'déposée',
  'admin.archives.status.processing': 'en cours',
  'admin.archives.status.done': 'terminée',
  'admin.archives.status.failed': 'échec',
  'admin.archives.col.user': 'Utilisateur',
  'admin.archives.col.status': 'Statut',
  'admin.archives.col.progress': 'Importées / ignorées / échecs',
  'admin.archives.col.error': 'Dernière erreur',
  'admin.archives.col.updated': 'Mis à jour',
  'admin.archives.attempts': '{n} tentative(s)',
  'admin.archives.members': 'sur {n} fichiers',
  'admin.archives.requeue': 'Relancer',

  // ── Méthode page ─────────────────────────────────────────────────────────────
  'methode.heroTitle': "Comment ça marche ?",
  'methode.heroSubtitle': "Des vrais chemins, pas des lignes sur une carte.",
  'methode.principleTitle': "Le principe",
  'methode.rawIntro': "La carte communautaire affiche vos vraies traces GPS, précises, telles que vous les avez roulées. Aucun algorithme ne les redessine sur un réseau de routes. Plus un chemin est parcouru, plus il ressort : les itinéraires populaires émergent de la superposition de milliers de traces.",
  'methode.rawNoMatch': "Pas de recalage sur une carte, pas d'accrochage à un réseau connu. Ce que vous voyez, c'est l'agrégat brut de vraies sorties — y compris les lignes de désir : ces singletracks et pistes forestières qu'aucune carte ne référence.",
  'methode.pill.masking': "Extrémités masquées",
  'methode.pill.commercial': "Licence commerciale sur demande",
  'methode.rawBuildTitle': "Des traces brutes, superposées",
  'methode.rawBuildDesc': "La recette est simple : on lit votre fichier GPX, on masque le début et la fin, puis on superpose. La popularité est comptée sur une grille fine (~5 m), mais la ligne dessinée reste votre géométrie exacte — la grille ne fait que colorer, jamais redessiner.",
  'methode.rawStep1Title': "Vous déposez",
  'methode.rawStep1Desc': "GPX, FIT ou export Strava",
  'methode.rawStep2Title': "On masque",
  'methode.rawStep2Desc': "les extrémités de chaque trace",
  'methode.rawStep3Title': "On superpose",
  'methode.rawStep3Desc': "la popularité fait ressortir les corridors",
  'methode.rawLatticeDetails': "Comment la popularité est calculée",
  'methode.rawLatticeDetail': "Chaque point masqué est rangé dans une cellule d'une grille de densité (~5 m de côté). La cellule compte les passages et les utilisateurs distincts — ce comptage donne l'intensité (la couleur) du tracé. Mais la ligne affichée reste la polyligne GPS réelle, précise : la grille sert de compteur, jamais de gabarit.",
  'methode.communityGrows': "Plus la communauté partage de traces, plus les trous se comblent.",
  'methode.privacyTitle': "Vie privée : le masquage des extrémités",
  'methode.privacyDesc': "Vos traces apparaissent précises, mais le début et la fin de chaque activité sont automatiquement rognés (environ 200 m) pour ne jamais révéler votre domicile ou votre lieu de travail.",
  'methode.privacyMaskCallout': "C'est un masquage des extrémités, pas de la K-anonymité : on coupe les bouts sensibles de chaque trace plutôt que de fondre les traces entre elles.",
  'methode.privacyFloorTitle': "Le seuil de contributeurs distincts",
  'methode.privacyFloorDetail': "En complément, un plancher d'utilisateurs distincts par cellule peut masquer les secteurs parcourus par trop peu de monde. Pendant la bêta privée il est réglé sur 1 (tout s'affiche, y compris une trace solitaire) ; il sera relevé à mesure que la communauté grandit.",
  'methode.privacyNotKanon': "L'ancien modèle de K-anonymité par segment recalé n'existe plus : la carte brute le remplace par ces deux garde-fous, complétés par un export réservé aux membres.",
  'methode.provenanceTitle': "Vos traces, votre consentement",
  'methode.provenanceDesc': "Seules les traces que vous déposez vous-même — votre export Strava (.zip), ou des fichiers GPX/FIT — alimentent la carte communautaire publique, avec votre consentement explicite et sous licence ouverte ODbL.",
  'methode.licenseTitle': "Ouvert pour tous, payant pour les plateformes fermées",
  'methode.licenseDesc': "La carte communautaire est publiée sous ODbL 1.0 : réutilisation libre — y compris commerciale — à deux conditions, créditer les contributeurs et republier toute base dérivée sous la même licence ouverte (partage à l'identique). C'est ce qui garantit que le commun reste un commun.",
  'methode.licenseDual': "Pourquoi ce double régime ? Pour éviter que des mastodontes du secteur utilisent les données de la communauté sans accord. Une plateforme fermée qui refuse le partage à l'identique (intégrer nos données dans un produit propriétaire sans les rouvrir) doit acquérir une licence commerciale séparée — contact : paul@epauler.fr. En contribuant, vous accordez au projet ce droit non exclusif ; les revenus financent l'infrastructure. Vos traces, elles, restent libres en ODbL pour tout le monde, pour toujours.",
  'methode.provenanceApi': "Les activités synchronisées via l'API Strava restent strictement personnelles (politique API Strava §5.4/§5.10) : jamais sur la carte publique, jamais dans l'export ouvert.",
  'methode.integrityTitle': "Traces intouchées",
  'methode.integrityDesc': "Votre fichier GPX est stocké exactement tel que vous l'avez enregistré. On ne le recalcule jamais, on ne le simplifie pas, on ne l'accroche à aucune route. Seules les deux extrémités sont masquées par souci de confidentialité — le reste est conservé au trait près.",
  'methode.routingTitle': "Le routage ? On vous laisse les meilleurs outils",
  'methode.routingDesc': "Chemins communs est une carte de popularité ouverte et une source de traces. Ce n'est pas un routeur — l'écosystème le fait mieux que nous. Exportez n'importe quelle trace en GPX et ouvrez-la dans gpx.studio, BRouter ou Komoot pour construire et suivre votre itinéraire.",
  'methode.routingNote': "Le routeur intégré a été retiré : être un routeur n'est pas notre métier.",
  'methode.footerExplain': "Expliquer ce que nous faisons, reconnaître ce que nous ne savons pas.",
  'methode.exploreMap': "Explorer la heatmap →",
  'methode.footerLicense': "Code source AGPLv3 · Données ODbL 1.0 · Extrémités masquées",

  // ── Privacy page ─────────────────────────────────────────────────────────────
  'privacy.lastUpdate': 'Dernière mise à jour : 29 juillet 2026',
  'privacy.dataCollected': '2. Données collectées',
  'privacy.activityMeta': "Métadonnées de l'activité : nom, sport, distance, dénivelé, temps de déplacement",
  'privacy.techData': 'Données techniques : adresse IP, type de navigateur (logs serveur, conservés 30 jours)',
  'privacy.privateVsCommunity': '3. Données privées vs. données communautaires',
  'privacy.activitiesPrivate': "Vos activités sont privées. Elles ne sont jamais partagées, vendues ou rendues accessibles à d'autres utilisateurs.",
  'privacy.kAnonymity': "La carte communautaire est publique et ouverte. Elle n'est alimentée que par les traces que vous déposez vous-même (fichiers GPX/FIT ou export Strava), avec votre consentement explicite — jamais par les activités synchronisées via l'API Strava. Vos traces y apparaissent précises, mais le début et la fin de chaque activité sont automatiquement masqués (200 m par défaut) afin de ne pas révéler vos lieux sensibles (domicile, travail). Pendant la phase de bêta privée, une trace peut être visible individuellement ; un seuil de contributeurs distincts, renforcé à mesure que la communauté grandit, limitera progressivement l'affichage aux secteurs parcourus par plusieurs utilisateurs.",
  'privacy.odbl': "Les données de la carte communautaire sont publiées en open data sous licence ODbL 1.0 (Open Database License) : chacun peut les réutiliser et les télécharger, à condition de créditer la source et de conserver la même licence ouverte (partage à l'identique). En parallèle, les contributeurs (consentement v5) accordent au projet le droit non exclusif de proposer ces données sous licence commerciale séparée aux acteurs qui ne souhaitent pas respecter le partage à l'identique — les revenus financent le projet.",
  'privacy.usedFor': 'Vos données sont utilisées exclusivement pour :',
  'privacy.routeCalc': 'Vous permettre d\'exporter vos traces en GPX vers des outils tiers (gpx.studio, BRouter, Komoot)',
  'privacy.noSponsored': 'Pas de résultat sponsorisé ni de contenu promu sur la carte',
  'privacy.oauthExplain': "Lorsque vous connectez un compte Strava ou Garmin Connect, nous accédons uniquement à vos activités via leur API officielle, avec votre consentement explicite (OAuth2).",
  'privacy.revokeAccess': "Vous pouvez révoquer l'accès à tout moment depuis les paramètres de votre compte Strava ou Garmin Connect. La révocation stoppe toute synchronisation future.",
  'privacy.noPassword': "Nous ne stockons pas votre mot de passe Strava ou Garmin — uniquement un jeton d'accès chiffré.",
  'privacy.hosting': '6. Hébergement et sécurité',
  'privacy.hostingGcp': 'Hébergement : Google Cloud Platform (région europe-west1, Belgique)',
  'privacy.retention': 'Vos données sont conservées tant que votre compte est actif.',
  'privacy.deleteAccount': 'Demander la suppression complète de votre compte et de toutes vos données en nous contactant par email',
  'privacy.gdpr': 'Conformément au Règlement Général sur la Protection des Données, vous disposez des droits suivants :',
  'privacy.rightAccess': 'Accès : consulter vos données personnelles',
  'privacy.rightPortability': 'Portabilité : exporter vos données (GPX)',
  'privacy.policyUpdate': "Cette politique peut être mise à jour. En cas de changement significatif, une notification sera affichée sur le site. La date de dernière mise à jour est indiquée en haut de cette page.",

  // ── Map — Account dropdown ───────────────────────────────────────────────────
  'map.layers': 'Calques',
  'map.account.loggedAs': 'Connecté en tant que',
  'map.account.viewStats': 'Voir mes stats',
  'map.account.myTraces': 'Mes traces',
  'map.account.importGarmin': 'Importer depuis Garmin',
  'map.account.importKomoot': 'Importer depuis Komoot',
  'map.account.komootDesc': 'Exporter vos GPX → importer ici',
  'map.account.importContribute': 'Importer / Contribuer',
  'map.account.importContributeDesc': 'GPX, ZIP, export Strava / Garmin / Komoot',
  'map.account.useAsOverlay': 'Utiliser la heatmap par sport pour tracer',
  'map.account.useAsOverlayDesc': 'Calque gpx.studio / VisuGPX, par sport',
  'map.menuButton': 'Menu',
  'map.account.createOrLogin': 'Créer un compte ou connexion',
  'map.account.accountOf': 'Compte de {name}',
  'map.account.tracesImported': '{count} activité{s} importée{s}',
  'map.account.admin': 'Admin',
  'map.account.adminDesc': 'Dashboard monitoring',
  'map.account.logout': 'Se déconnecter',

  // ── Long-running import reassurance + post-login notifications ──────────────
  'strava.canCloseTab': 'Vous pouvez fermer cet onglet — l\'import continue en arrière-plan.',
  'strava.notifyOnReturn': 'Vous recevrez une notification à votre prochaine connexion.',
  // ── Import progress flow (stepper, ETA, phase titles) ──────────────────────
  'strava.phase.discovering': 'Découverte',
  'strava.phase.ingesting': 'Import',
  'strava.phase.gpsUpgrade': 'GPS HD',
  'strava.phase.photoImport': 'Photos',
  'strava.eta.fewSeconds': '~quelques secondes',
  'strava.eta.remaining': 'restantes',
  'strava.page.label': 'Page',
  'strava.importingActivities': 'Import de {count} activités',
  'strava.canLeaveImport': 'Vous pouvez quitter — l\'import continue en arrière-plan',
  'strava.tooLong': 'Trop long ?',
  'strava.photoImportTitle': 'Import des photos',
  'strava.photosImported': '{count} photo(s) importée(s)',
  'strava.searchingPhotos': 'Recherche des photos…',
  'strava.failedAtPhase': 'Échec en phase',
  'strava.seeDetails': 'Voir détails',
  'strava.gpsUpgradeInline': 'Amélioration GPS',
  'strava.resync': 'Re-synchroniser',
  'strava.tipFasterGpx': 'Import plus rapide avec GPX',
  'strava.tip': 'Astuce',
  'strava.stravaEtaTip': 'Avec {count} activités, l\'import via Strava prendra ~{min} min (limite API Strava).',
  'strava.zipEmailHint': 'Strava vous enverra un email avec un ZIP. Importez-le sur',
  'strava.theMap': 'la carte',
  'strava.withImportButton': 'avec le bouton Importer.',
  'strava.heatNote': ' — vos traces apparaîtront sur la heatmap dans quelques minutes',
  'strava.importingFiles': 'Import de {count} fichier(s)…',
  'strava.gpxAltTitle': 'Alternative rapide : export GPX Strava',
  'strava.gpxStep1': 'Allez sur',
  'strava.gpxStep2': 'Cliquez',
  'strava.requestDataBtn': 'Demander vos données',
  'strava.gpxStep2Note': '(ne supprime pas votre compte)',
  'strava.gpxStep3': 'Attendez l\'email de Strava (quelques heures)',
  'strava.gpxStep4': 'Importez le ZIP ci-dessus — instantané !',
  // ── Strava import wizard — strings previously hardcoded in app/strava/page.tsx ──
  'strava.communityMap': 'Carte communautaire',
  'strava.contributeHeatmap': 'Contribuer à la heatmap',
  'strava.canLeavePage': "Vous pouvez quitter la page, l'import continue en arrière-plan.",
  'strava.importProgress': 'Import {current}/{total}...',
  'strava.resultImported': '{count} importée{s}',
  'strava.resultSkipped': '{count} ignorée{s}',
  'strava.resultFailed': '{count} erreur{s}',
  'strava.compatible': 'Compatible : Strava (.gpx), Garmin (.fit/.gpx), Komoot (.gpx), Wahoo (.fit)',
  'strava.chooseFiles': 'Choisir les fichiers',
  'strava.blockArchiveTitle': 'Mon archive .zip (Strava ou Garmin)',
  'strava.blockFilesTitle': 'Mes traces GPX / FIT',
  'strava.chooseArchive': 'Choisir mon archive .zip',
  'strava.archiveHelpLink': 'Comment obtenir mon archive Strava (3 min)',
  'strava.sportFromArchive': 'Le sport est lu automatiquement depuis ton archive.',
  'strava.sportConfirmTitle': 'Ces traces sont du :',
  'strava.importViaStrava': 'Importer via Strava (plus lent)',
  'strava.queued': "En file d'attente",
  'strava.queuedOther': 'Un autre import est en cours sur votre compte.',
  'strava.queuedWait': 'Le vôtre démarrera dès que le précédent termine. Vous pouvez fermer cet onglet.',
  'strava.readingHistory': "Lecture de l'historique Strava...",
  'strava.statNew': 'nouvelle{s}',
  'strava.statError': 'erreur{s}',
  'strava.statImported': 'importée{s}',
  'strava.startingImport': "Démarrage de l'import...",
  'strava.connectingReading': 'Connexion à Strava et lecture des premières pages.',
  'strava.continuesBackground': 'Continue en arrière-plan',
  'strava.gpsHighQuality': 'GPS haute qualité ✓',
  'strava.importStravaMin': 'Import Strava : ~{minutes} min',
  'strava.willExportGpx': 'Je vais exporter mes GPX',
  'strava.continueWithStrava': 'Continuer avec Strava',
  'notif.markRead': 'Marquer comme lu',
  'notif.markAllRead': 'Tout marquer comme lu',
  'notif.activitySynced.title': 'Sortie synchronisée',
  'notif.activitySynced.body': 'Ta sortie « {name} » est synchronisée dans ta vue perso ✓',
  'notif.activitySynced.bodyNoName': 'Ta sortie est synchronisée dans ta vue perso ✓',

  // ── MAP i18n consolidation (fix/map-i18n-consolidation) ──────────────────────
  // Toolbar
  'map.toolbar.heatmapLayer': '🔥 Heatmap communautaire',
  'map.offroadCombined': 'Off-road (VTT+Gravel)',
  'map.toolbar.timeAll': 'Tout',
  'map.toolbar.time1y': '1 an',
  'map.toolbar.time60d': '60j',
  'map.toolbar.time30d': '30j',
  'map.dfciTracks': 'Pistes DFCI',
  'map.dfciTracksCount': 'Pistes DFCI ({count})',
  'map.toolbar.moreLayers': 'Plus de calques',
  'map.toolbar.cellCoverage': 'Couverture cellules',
  'map.toolbar.hillshade': 'Relief / Ombrage',
  'map.toolbar.stravaPhotos': 'Photos Strava',
  'map.toolbar.waymarkedHeader': 'Sentiers balisés',
  'map.toolbar.basemap': 'Fond de carte',
  'map.toolbar.exportTitle': 'Télécharger la heatmap communautaire (PMTiles / GPX / GeoJSON — pour gpx.studio, VisuGPX · ODbL)',
  'map.toolbar.exportAria': 'Télécharger la heatmap communautaire',
  'map.toolbar.exportBtn': '⬇️ Exporter',
  'map.toolbar.exportSection': 'Exporter',
  'map.toolbar.exploreModeOn': '🔍 Mode exploration',
  'map.toolbar.exploreModeOff': '🔍 Explorer la heatmap',
  // Basemap picker labels + titles
  'map.basemap.label.bright': 'Claire',
  'map.basemap.label.dark': 'Sombre',
  'map.basemap.label.liberty': 'Vélo',
  'map.basemap.label.cyclosm': 'CyclOSM',
  'map.basemap.label.ign': 'IGN',
  'map.basemap.label.hybrid': 'Hybride',
  'map.basemap.label.satellite': 'Satellite',
  'map.basemap.title.bright': 'Fond de carte clair',
  'map.basemap.title.dark': 'Fond sombre (meilleur contraste heatmap)',
  'map.basemap.title.liberty': 'Fond cycliste avec pistes et chemins',
  'map.basemap.title.ign': 'IGN Plan v2 — topo française',
  'map.basemap.title.hybrid': 'Satellite + IGN semi-transparent',
  'map.basemap.title.satellite': 'Imagerie satellite Esri',
  'map.waymarked.hiking': 'Randonnée (GR/PR)',
  'map.waymarked.cycling': 'Vélo (EuroVelo)',
  'map.waymarked.mtb': 'VTT',
  // Import modals (Garmin / Komoot / RoutingInfo / Lightbox)
  'map.howRouting.signalsIntro': 'Pour cela, nous combinons plusieurs signaux :',
  'map.howRouting.profileNote': 'Le profil choisi (route, gravel, VTT…) influence ces priorités.',
  'map.howRouting.learnMore': 'En savoir plus →',
  'map.lightbox.photo': 'Photo',
  // Map page — default names
  'map.activityDefaultName': 'Activité',
  // Map page — import flow (single-file / ZIP)
  // Map page — warming messages + overlays / popups
  'map.loadingCommunityTraces': 'Chargement des traces communautaires',
  'map.edgesSuffix': ' ({count} edges)',
  'map.betaImportLink': 'Importer mes traces',
  'map.activitiesLoadError': 'Impossible de charger vos parcours. Réessayez plus tard.',
  'map.loadingHeatmap': 'Chargement de la heatmap...',
  'map.gpxDropHint': 'Glisser un fichier .gpx pour le visualiser',
  'map.closePreview': 'Fermer la prévisualisation',
  'map.import': 'Importer',
  'map.importing': 'Import…',
  'map.imported': 'Importé',
  'map.importError': 'Échec de l\'import — réessayez.',
  'map.addAnnotation': 'Ajouter une annotation',
  'map.annotationNotePlaceholder': 'Note (optionnel)',
  'map.segmentHeatmap': 'Segment heatmap',
  'map.contributors': '{count} contributeur{s}',
  'map.passes': '{count} passage{s}',
  'map.directionOfTravel': 'Sens de passage',
  'map.traceFromHere': "Tracer à partir d'ici",
  'map.sportFilter.all': 'Tous',
  'map.sportFilter.running': 'Course',
  'map.comparison': 'Comparaison',
  'map.openOnPanoramax': 'Ouvrir sur Panoramax →',
  'map.linkCopied': 'Lien copié !',
  // Legend
  'map.legend.popularity': 'Popularité',
  'map.legend.offroad': 'Off-road (VTT + Gravel)',
  // Selected activity card
  'map.activity.distance': 'Distance',
  'map.activity.elevGain': 'D+',
  'map.activity.date': 'Date',
  'map.activity.viewDetails': 'Voir les détails',
  'map.activity.similar': 'Similaires',
  // Activity photo strip
  'map.photos.stripLabel': 'Photos ({count})',
  'map.photos.stravaPhoto': 'Photo Strava',
  'map.photos.altFallback': 'Photo',

  // ── Calque / heatmap dans gpx.studio ──────────────────────────────────────
  'calque.breadcrumb': 'La heatmap en calque',
  'calque.title': 'La heatmap par sport, en calque dans gpx.studio',
  'calque.intro': "Superpose la heatmap communautaire D'UN SPORT (route, gravel, VTT, off-road, course) sur ta carte préférée, en calque transparent, pour préparer tes sorties. Choisis le sport, copie l'URL : trois réglages, trente secondes.",
  'calque.urlLabel': "L'adresse du calque",
  'calque.copy': 'Copier',
  'calque.copied': 'Copié ✓',
  'calque.stepsTitle': 'La marche à suivre',
  'calque.step1Title': 'Ouvre les réglages de carte',
  // Menu path validated by Paul in the real gpx.studio (2026-09-05); the
  // map-icon hover is the alternative route to the same panel.
  'calque.step1Text': "Sur gpx.studio, menu « Settings » → « Map Layers ». (Ou : survole l'icône de carte en haut à droite puis clique la roue crantée — même panneau.)",
  'calque.step2Title': 'Ajoute une couche personnalisée',
  'calque.step2Text': "Dans « Custom layers », choisis « Ajouter une couche » (Add custom layer), puis renseigne exactement ces quatre champs :",
  'calque.step3Title': 'Enregistre',
  'calque.step3Text': "Clique « Ajouter la couche », puis « Enregistrer ». La couche est mémorisée dans ton navigateur pour tes prochaines visites.",
  'calque.step4Title': 'Active le calque',
  'calque.step4Text': "Survole à nouveau l'icône de carte, va dans « Superpositions › Personnalisé » (Overlays › Custom) et coche Chemins Communs.",
  'calque.step4Text2': "Les traces de la communauté apparaissent en violet → orange par-dessus ton fond de carte. Plus une portion est empruntée, plus elle ressort chaude et lumineuse.",
  'calque.panelTitle': 'Nouvelle couche personnalisée',
  'calque.fieldName': 'Nom',
  'calque.fieldUrl': 'URL des tuiles',
  'calque.fieldZoom': 'Zoom max',
  'calque.fieldType': 'Type',
  'calque.valType': 'Superposition · Overlay',
  'calque.trap1Title': "La bonne URL, c'est celle en .png",
  'calque.trap1Text': "Colle bien le gabarit en .png. Ne colle pas l'adresse en .json (gpx.studio la prendrait pour du vectoriel et n'afficherait rien), ni le fichier .pmtiles.",
  'calque.trap2Title': 'Choisis « Superposition », pas « Fond de carte »',
  'calque.trap2Text': "Nos tuiles sont transparentes — juste les traces, sur du vide. En fond de carte (basemap), tu verrais les traces flotter sur un écran gris ; en superposition (overlay), elles se posent sur ta carte habituelle.",
  'calque.whyTitle': 'Pourquoi en calque ?',
  'calque.whyText': "La heatmap n'est pas une carte complète : c'est une couche de traces à poser au-dessus de ton fond préféré (OpenStreetMap, satellite, IGN…). C'est la même logique que le calque « Heatmap » de Strava.",
  'calque.noteZoomT': 'Zoom',
  'calque.noteZoom': "Données jusqu'au niveau 14. Au-delà, gpx.studio agrandit la dernière tuile — c'est normal.",
  'calque.noteCoverageT': 'Couverture',
  'calque.noteCoverage': 'France métropolitaine. Le calque se densifie à mesure que la communauté contribue ses traces.',
  'calque.noteAppsT': 'Autres applis',
  'calque.noteApps': 'La même URL marche dans toute appli qui accepte une couche raster XYZ (VisuGPX, MapLibre, Leaflet…).',
  'calque.noteLicenseT': 'Licence',
  'calque.noteLicense': "Données © contributeurs Chemins Communs, réutilisables en citant la source et en partageant à l'identique —",
};

export default fr;
